import axios, { AxiosResponse } from 'axios';
import api from 'api/base';
import {
  RefreshTokenResponse,
  SignInPayload,
  SignInResponse,
} from 'features/auth/api/types';
import config from 'shared/constants/config';
import { getRefreshTokenFromLocalStorage } from 'utils/local-storage';

export const checkAuthStatusAPI = async (): Promise<AxiosResponse<boolean>> => {
  return api.get<boolean>('/admin/auth/check');
};

export const signInAPI = async (
  payload: SignInPayload
): Promise<AxiosResponse<SignInResponse>> => {
  return api.post<SignInResponse>('/admin/auth/sign-in', payload);
};

export const signOutAPI = async (): Promise<AxiosResponse> => {
  const refreshToken = getRefreshTokenFromLocalStorage();
  return api.post(
    '/admin/auth/sign-out',
    {},
    {
      headers: refreshToken ? { 'X-Refresh-Token': refreshToken } : {},
    }
  );
};

export const refreshAccessTokenAPI = async (): Promise<
  AxiosResponse<RefreshTokenResponse>
> => {
  const refreshToken = getRefreshTokenFromLocalStorage();
  return axios.post<RefreshTokenResponse>(
    `${config.API_URL}/v1/admin/auth/refresh`,
    {},
    {
      withCredentials: true,
      headers: refreshToken ? { 'X-Refresh-Token': refreshToken } : {},
    }
  );
};
